// libraries
import Vue from 'vue'

const resource = 'inbox'
const resourceName = 'datos'

const state = {
  clientConnected: false
}

state[resource + 's'] = []

// functions receive state
const getters = {
  isClientConnected: (state) => state.clientConnected
}

// functions receive context and params
const actions = {
  // credentials for mqtt connection
  async client ({ commit }, params) {
    try {
      if (params.attempt && params.attempt >= 3) {
        params.callback({ error: `Error obteniendo ${resourceName} de cliente.` })
      }
      const res = await Vue.request.get(`account/${params.account_id}/${resource}_client`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        console.log('%c Error conectando con servicio en tiempo real. <-', 'color:#ff0000')
        if (!params.attempt) params.attempt = 0
        params.attempt++
        actions.client({}, params)
      }
    } catch (e) {
      console.error(e)
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceName} de cliente.` }) }
    }
  },
  // send message
  async message ({ commit }, params) {
    try {
      const res = await Vue.request.post(`account/${params.account_id}/${resource}_message`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: 'Error enviando mensaje.' })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error enviando mensaje.' }) }
      console.error(e)
    }
  },
  // search messages
  async search({ commit, dispatch }, { accountId, params, callback }) {
    try {
      const { page } = params
      if (Number(page) === 1)commit('conversation/resetConversations', null, { root: true })
      const res = await Vue.request_search.post(`search/messages/${accountId}`, params)
      const { success } = res.data || {}
      if (!success) return
      const { data } = res
      const { messages } = data
      commit('conversation/setMessagesSearch', messages, { root: true })
      if (callback) return callback(data)
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error obteniendo en la búsqueda.' }) }
      console.error(e)
    }
  },
  // search for user conversation
  async user ({ commit, dispatch }, params) {
    try {
      commit('conversation/setItems', [], { root: true })
      const res = await Vue.request.get(`account/${params.account_id}/${resource}_user`, { params: params.params || {} })
      if (res.data.success && params.callback) {
        if (params.params.page === 1) { commit('conversation/setItems', [], { root: true }) }
        commit('conversation/concatItems', res.data.resource, { root: true })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceName}.` }) }
      console.error(e)
    }
  },
  // search in cases
  async searchCases ({ commit, dispatch }, params) {
    try {
      //commit('group/setCases', [], { root: true })
      const { params: functionParams = {} } = params
      const res = await Vue.request.get(`account/${params.account_id}/searchCases`, { params: functionParams })
      if (res.data.success && params.callback) {
        if (params.params.page === 1) { commit('group/setCases', [], { root: true }) }
        commit('group/concatCases', res.data.resource, { root: true })
        commit('group/setTotal', res.data.total, { root: true })
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: `Error obteniendo ${resourceName}.` })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: `Ocurrió un error obteniendo ${resourceName}.` }) }
      console.error(e)
    }
  },
  async typing ({ commit }, params) {
    try {
      const res = await Vue.request.post(`account/${params.account_id}/${resource}_typing`, params)
      if (res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({ error: 'Error enviando typing.' })
      }
    } catch (e) {
      if (params.callback) { params.callback({ error: 'Ocurrió un error enviando typing.' }) }
      console.error(e)
    }
  }
}

// functions receive state
const mutations = {
  setItems (state, items) {
    state[resource + 's'] = items
  },
  updateClientConnected (state, value) {
    state.clientConnected = value
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
